import { gql } from 'graphql.macro';

export const getMaterialMacrosTemplate = gql`
    query materialMacros {
        materialMacros {
            _id
            name
            materials {
                _id
                material {
                    _id
                    materialCode
                    description
                    vat
                    batchInventoryManagement
                    batches {
                        batchNumber
                        quantity
                        fullBatchQuantity
                        createdOn
                        closed
                        closedDate
                    }
                }
            }
        }
    }
`;
